import { FC } from "react";
import alertsolid from "styleguide/icons/ds2/alertsolid.svg";

interface NoResultsFoundProps {
  title?: string;
  message?: string;
  dsCardClassName?: string;
}

const NoResultsFound: FC<NoResultsFoundProps> = ({
  title = "No results found",
  message = "There are no matches found with your search criteria.",
  dsCardClassName = "w-full!",
}) => {
  return (
    <fieldset
      className={`ds-card m-0! p-0! ${dsCardClassName ?? ""}`}
      data-ds-theme="vessel"
      data-ds-variant="thumbnail"
      data-ds-version="2"
      aria-labelledby="card-0-title"
    >
      <div className="flex w-full flex-col m-6!">
        <div>
          <div className="flex">
            <div className="ds-card__content p-0!">
              <div className="flex gap-6 mt-4">
                <div className="">
                  <img
                    src={alertsolid}
                    alt="card icons"
                    className="h-11! w-11!"
                  />
                </div>
                <div>
                  <p className="p1 -medium my-1.5!" id="card-0-title">
                    {title}
                  </p>
                  <p className="p2 mt-1.5! mb-0!">{message}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  );
};

export default NoResultsFound;
 